<sdds-theme name="scania" global="true"></sdds-theme>
<p-toast></p-toast>

<!-- Shown when a newer version has been deployed, see UpdateService.
     Uses PrimeNG's own toast classes, so it is styled by the theme like the other toasts (incl. dark mode). -->
<p-toast key="reload" styleClass="update-toast">
  <ng-template pTemplate="message" let-message>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail">{{ message.detail }}</div>
      <p-button class="update-toast-action" label="Reload" icon="pi pi-refresh" (onClick)="updateService.reloadApplication()" />
    </div>
  </ng-template>
</p-toast>

<div class="layout">
  
  @let userData = authService.userData$ | async;
 @if (userData?.isLoggedIn && userData?.sessionUID) {
  <div class="header-container" appHeaderHeight>
    <app-header></app-header>
  </div>
  <app-spinner [isLoading]="(isLoading$ | async)"></app-spinner>
  <main class="main">
    <router-outlet></router-outlet>
  </main>
  @if (isLoadingBackground$ | async) {
    <div style="position: fixed; bottom: 5rem; left: 8rem; color: grey">Loading...</div>
  }
} @else if (isProcessingAuthentication()) {
  <app-spinner [isLoading]="true"></app-spinner>
} @else {
  <div class="sign-in">
    <p-card styleClass="sign-in-card">
      <p class="sign-in-message">Welcome to Configurator. Please sign in to continue.</p>
      <p-button icon="pi pi-sign-in" label="Sign in" (click)="authService.login()"/>
    </p-card>
  </div>
}

</div>

